module.exports = __webpack_public_path__ + "img/9791189015381.8f6cffd5.jpg";